import React from 'react';
import './DetailsPage.css'
const DetailsPage = () => {
    return (
        <div>
            <div className='details text-center'>
                <img className='images' src="https://olbia.wphunters.com/wp-content/uploads/2020/06/122@2x.png" alt="" />
            </div>
        </div>
    );
};

export default DetailsPage;